(function ($) {

  'use strict';

  function scrolled() {
    this._st = window.pageYOffset || document.documentElement.scrollTop
    this._last = this._last || 0
    document.body.classList.toggle('scrolled', (this._st > 50))
    this._last = (this._st < 0 ? 0 : this._st)
  }
  window.addEventListener('scroll', throttle(scrolled, 100))

  // dispatch trigger event from data-trigger element
  document.body.addEventListener('click', function (e) {
    if (!!e.target.dataset.trigger) {
      e.preventDefault()
      document.dispatchEvent(new CustomEvent(e.target.dataset.trigger, { detail: e.target }))
    }
  })

  // trigger goto url
  document.addEventListener('goto', function (e) {
    if (!!e.detail.dataset.url)
      document.location.href = e.detail.dataset.url
  })

  // NEWS

  // submit news filters
  // document.body.addEventListener('change', function (e) {
  //   var form = document.querySelector('#views-exposed-form-news-list')
  //   if (form && form.contains(e.target)) {
  //     form.querySelectorAll('select').forEach(function(el){
  //       el.setAttribute('disabled',true)
  //     })
  //     form.submit()
  //   }
  // })

  // trigger toggle shares
  document.addEventListener('share-toggle', function (e) {
    e.detail.nextElementSibling.classList.toggle('open')
  })
  /**************** UPLOAD BTN  ***************/
  $( '.form-file' ).each( function()
  {
    var $input	 = $( this ),
      $label	 = $input.closest( 'label' ),
      labelVal = $label.html();

    $input.on( 'change', function( e )
    {
      var fileName = '';

      if( this.files && this.files.length > 1 )
        fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
      else if( e.target.value )
        fileName = e.target.value.split( '\\' ).pop();

      if( fileName )
        $label.find( 'span' ).html( fileName );
      else
        $label.html( labelVal );
    });

    // Firefox bug fix
    $input
    .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
    .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
  });

	/**************** INIT EFFECT APPEAR ***************/
	AOS.init({
		disable: 'mobile',
		once: true,
	});


})(jQuery)
